import { render } from "./footer-tools.vue?vue&type=template&id=2acce9c7&scoped=true"
import script from "./footer-tools.vue?vue&type=script&lang=js"
export * from "./footer-tools.vue?vue&type=script&lang=js"

import "./footer-tools.vue?vue&type=style&index=0&id=2acce9c7&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acce9c7"]])

export default __exports__